import { getUserAgent } from './get-user-agent';
export function isMobile(ua) {
    if (ua === void 0) { ua = ''; }
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(getUserAgent(ua));
}
